<template>
  <HubContainer id="companyGlobalSettingsHub">

    <template v-if="atLeastDistributor">
      <HubSection large icon="icon/hub/payment-taxes.svg" v-if="$store.getters.loggedUserHasViewPaymentSettingsPermission"
                  :title="$t('companies.settings.payment')"
                  :description="$t('companies.settings.payment_description')"
                  :buttonAction="goToPayment">
      </HubSection>

      <HubSection large icon="icon/hub/shipper.svg" v-if="atLeastSuperAdmin"
                  :title="$t('companies.settings.shipper')"
                  :description="$t('companies.settings.shipper_description')"
                  :buttonAction="goToShipper">
      </HubSection>

      <HubSection large icon="icon/hub/customer-accounts.svg" v-if="!exactlyDistributor"
                  :title="$t('loyalty.title')"
                  :description="$t('loyalty.description')"
                  :buttonAction="goToLoyalty">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "companyGlobalSettingsHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.global_settings";
      this.$store.state.pageIcon = "/icon/nav/revenue-center.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastDistributor() {
        return this.$store.getters.loggedUserHasDistributor;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      getContextName() {
        if (this.branch && this.company) {
          return this.company.name;
        }
        return "";
      }
    },

    methods: {
      goToPayment() {
        this.$router.push(this.$router.buildContext("/settings/payment"));
      },
      goToShipper() {
        this.$router.push(this.$router.buildContext("/settings/shipper"));
      },
      goToUber() {
        this.$router.push(this.$router.buildContext("/settings/uber-eats"));
      },
      goToLoyalty() {
        this.$router.push(this.$router.buildContext("/loyalty-config"));
      }
    }
  }
</script>